import { appStore } from '@kaltura-ott/tvpil-shared';

import { formatLocalTimeV2 } from 'utils';

export interface Props {
  time: Date | number;
  minutes?: number;
}

export function useLocalTime(time: Date | number, minutes = 0) {
  const { localizationStore: { displayLanguage, latinLanguage } } = appStore;
  const locale = latinLanguage || displayLanguage;
  const result = formatLocalTimeV2({ locale, time, minutes });

  return result;
}
